// export const initialState = {
//     username: null,
//     itemslist:[ ]
// };

//user types:
// guest, registerduser
// export const initialState = {
//     username: null,
//     itemslist:[],
//     filters: {
//         price: null,
//         brands: []
//     }
// };

export const initialState = {
    username: null,
    itemslist:[],
    brands: []
};